'use client'
// import {OurTeamCard} from "@/ui/OurTeam/OurTeamCard/OurTeamCard";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import { CONTENTS1, CONTENTS2 } from '@/data/content'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import OurTeamCard from './OurTeamCard/OurTeamCard'

const FiltersCard = [
  'Nadzeya Sankovich',
  'Ada Jonuse',
  'Muhammad Furqan Arshad',
  'Ned Zimin'
]

const OurTeam = () => {
  const [modulo, setModulo] = useState(4)
  const [animation, setAnimation] = useState(false)
  const getAnimation = (
    animation: boolean,
    modulo: number,
    contentId: number
  ) => {
    if (modulo === 1) {
      return animation && (contentId % 2 === 1 ? 'fade-right' : 'fade-left')
    }

    switch (modulo) {
      case 4:
        switch (contentId % modulo) {
          case 1:
            return 'fade-right'
          case 2:
            return 'fade-up-right'
          case 3:
            return 'fade-up-left'
          case 0:
            return 'fade-left'
          default:
            return ''
        }
      case 3:
        switch (contentId % modulo) {
          case 1:
            return 'fade-right'
          case 2:
            return 'fade-up'
          case 0:
            return 'fade-left'
          default:
            return ''
        }
      case 2:
        switch (contentId % modulo) {
          case 1:
            return 'fade-right'
          case 0:
            return 'fade-left'
          default:
            return ''
        }
      default:
        return ''
    }
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setModulo(1)
        setAnimation(true)
      } else if (window.innerWidth < 1024) {
        setModulo(2)
        setAnimation(false)
      } else if (window.innerWidth < 1280) {
        setModulo(3)
        setAnimation(false)
      } else {
        setModulo(4)
        setAnimation(false)
      }
    }
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  const [contents1, setContents1] = useState(CONTENTS1)
  const [contents2, setContents2] = useState(CONTENTS2)

  useEffect(() => {
    const shuffledContents1 = shuffleArray(
      CONTENTS1.filter(content => !FiltersCard.includes(content.title))
    )

    const fixedMember = CONTENTS2.find(
      member => member.title === 'James Ryan' && member.id === 1
    )
    const otherMembers = CONTENTS2.filter(
      member =>
        !(member.title === 'James Ryan' && member.id === 1) &&
        !FiltersCard.includes(member.title)
    )

    const shuffledContents2 = fixedMember
      ? [fixedMember, ...shuffleArray(otherMembers)]
      : shuffleArray(otherMembers)

    setContents1(shuffledContents1)
    setContents2(shuffledContents2)
  }, [])

  const shuffleArray = (array: any[]) => {
    const newArray = [...array]
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[newArray[i], newArray[j]] = [newArray[j], newArray[i]]
    }
    return newArray
  }
  useEffect(() => {
    AOS.init({
      duration: 1000
    })
    AOS.refresh()
  }, [])
  return (
    <section className='md:container overflow-x-hidden relative md:-top-52  mx-auto  lg:px-0 pt-10 md:pt-12 2xl:pt-20'>
      <div className='relative top-0 '>
        <Image
          width={1223}
          height={1408}
          src={'/imgs/circle-back-shadow.svg'}
          alt=''
          className='absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 md:max-w-[900px] z-2'
        />
        <div className='relative  z-30 '>
          <h2 className='text-[40px] sm:text-[30px] md:text-[30px] sm:pb-0 lg:text-[45px] 2xl:text-[60px] font-semibold text-center translate-y-[25px] sm:translate-y-[10px] lg:-translate-y-[0px] xl:-translate-y-[0px] 2xl:-translate-y-[10px]  flex justify-center '>
            Our
            <span className='text-hero-blue-500 block sm:inline ml-2'>
              Team
            </span>
          </h2>
          <div className='absolute inset-0 translate-y-10 hidden sm:block'>
            <Image
              width={1512}
              height={82}
              src={'/compressed/our-team-line.svg'}
              alt='and much, much more'
              className='w-[100%] h-auto mx-auto -mt-[10px]'
            />
          </div>
        </div>
        <div className=' 3xl:w-[90%] md:max-w-[1300px] mx-auto px-4 lg:px-2 xl:px-[3vw] 2xl:px-0'>
          <div className='relative md:pt-40 pt-20 overflow-hidden'>
            <div className='container flex justify-start'>
              <Image
                width={202}
                height={55}
                src={'/compressed/apta-team.svg'}
                alt='and much, much more'
                className=''
              />
            </div>
            <section className='  container  mt-6 grid place-items-center md:place-items-start  sm:grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-4  md:gap-4 z-10  relative'>
              {contents1.map((content, index) => (
                <div
                  data-aos={getAnimation(animation, modulo, index + 1)}
                  key={content.id}
                  className={' h-full relative overflow-hidden sm:mt-0'}
                >
                  <OurTeamCard
                    cardType={'pink'}
                    title={content.title}
                    subtitle={content.subtitle}
                    icon={content.icon as any}
                    content={content.content}
                    href={content.href}
                    company={content.company}
                  />
                </div>
              ))}
            </section>
          </div>
          <section className='relative pb-10 md:pb-30 pt-16  overflow-hidden'>
            <div className='container flex justify-start'>
              <Image
                width={202}
                height={54}
                src={'/compressed/hero-team.svg'}
                alt='and much, much more'
                className=''
              />
            </div>
            <div className='  container  mt-6 grid place-items-center md:place-items-start  sm:grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-4  md:gap-4 z-10  relative'>
              {contents2.map((content, index) => (
                <div
                  data-aos={getAnimation(animation, modulo, index + 1)}
                  key={content.id}
                  className={' h-full  sm:mt-0 overflow-hidden  relative'}
                >
                  <OurTeamCard
                    cardType={'blue'}
                    title={content.title}
                    subtitle={content.subtitle}
                    icon={content.icon as any}
                    content={content.content}
                    href={content.href}
                    company={content.company}
                  />
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </section>
  )
}
export default OurTeam
